function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_10900_372583)"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.1162 4.11612C11.3506 3.8817 11.6685 3.75 12.0001 3.75C12.3316 3.75 12.6495 3.8817 12.884 4.11612C13.1184 4.35054 13.2501 4.66848 13.2501 5C13.2501 5.29002 13.4173 5.55405 13.6795 5.67802C14.7048 6.16287 15.5789 6.9176 16.2081 7.86132C16.8341 8.80031 17.1941 9.89117 17.2501 11.0181V14C17.2501 14.0301 17.2519 14.0602 17.2555 14.0901C17.3449 14.8284 17.6063 15.5354 18.0188 16.1542C18.0403 16.1864 18.0622 16.2183 18.0845 16.25H15.0001H9.00007H5.91569C5.93793 16.2183 5.9598 16.1864 5.98129 16.1542C6.39381 15.5354 6.65527 14.8284 6.74463 14.0901C6.74825 14.0602 6.75007 14.0301 6.75007 14V11.0181C6.80605 9.89117 7.16607 8.80031 7.79206 7.86132C8.41829 6.92198 9.2872 6.16987 10.3064 5.68479C10.3423 5.66871 10.3767 5.6499 10.4093 5.62862C10.5018 5.5686 10.5774 5.49051 10.6338 5.40135C10.7116 5.27814 10.7526 5.13381 10.7501 4.98684C10.7536 4.66008 10.8849 4.34743 11.1162 4.11612ZM8.25007 17.75H4.00007C3.65945 17.75 3.36161 17.5205 3.27482 17.1911C3.18804 16.8617 3.33411 16.5152 3.6305 16.3474C4.07327 16.0966 4.45097 15.7455 4.73322 15.3221C5.00753 14.9106 5.18422 14.4422 5.25007 13.9524V11C5.25007 10.9883 5.25034 10.9765 5.25089 10.9648C5.31684 9.55995 5.76383 8.19949 6.54398 7.02927C7.24375 5.97962 8.18789 5.11852 9.29256 4.51836C9.39049 3.96791 9.65478 3.45621 10.0555 3.05546C10.5713 2.53973 11.2707 2.25 12.0001 2.25C12.7294 2.25 13.4289 2.53973 13.9446 3.05546C14.3454 3.45621 14.6097 3.96791 14.7076 4.51836C15.8123 5.11853 16.7564 5.97962 17.4562 7.02927C18.2363 8.19949 18.6833 9.55995 18.7492 10.9648C18.7498 10.9765 18.7501 10.9883 18.7501 11V13.9524C18.8159 14.4422 18.9926 14.9106 19.2669 15.3221C19.5492 15.7455 19.9269 16.0966 20.3696 16.3474C20.666 16.5152 20.8121 16.8617 20.7253 17.1911C20.6385 17.5205 20.3407 17.75 20.0001 17.75H15.7501V18C15.7501 18.9946 15.355 19.9484 14.6517 20.6517C13.9485 21.3549 12.9946 21.75 12.0001 21.75C11.0055 21.75 10.0517 21.3549 9.34842 20.6517C8.64516 19.9484 8.25007 18.9946 8.25007 18V17.75ZM14.2501 17.75V18C14.2501 18.5967 14.013 19.169 13.5911 19.591C13.1691 20.0129 12.5968 20.25 12.0001 20.25C11.4033 20.25 10.831 20.0129 10.4091 19.591C9.98712 19.169 9.75007 18.5967 9.75007 18V17.75H14.2501Z",
  fill: "url(#paint0_linear_10900_372583)"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear_10900_372583",
  x1: 11,
  y1: 22,
  x2: 11,
  y2: 2,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#124897"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#2681E0"
})), React.createElement("clipPath", {
  id: "clip0_10900_372583"
}, React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));

var SvgNotiIconActive = function SvgNotiIconActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNotiIconActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/NotiIconActive.e7d6be27.svg";
export { ForwardRef as ReactComponent };